export const settingsAllSelector = ({settings}) => settings;

export const settingsIsMobileDeviceSelector = ({settings}) => settings.isMobileDevice;
